import React, { useCallback, useEffect, useState } from 'react';
import Layout from '../components/layout/AppLayout';
import Header from '../../shared/components/layout/Header';
import GridWrapper from '../../shared/components/layout/GridWrapper';
import Button from '../../shared/components/ui/Button';
import PaginationComponent from '../../shared/components/PaginationComponent';
import Table from '../../shared/components/layout/Table';
import {
  assignEngineer,
  getCustomerChangeRequests,
  getCustomerChangeRequestTasks
} from '../services/api/implementation/impl';
import { useMutation, useQuery } from '@tanstack/react-query';
import { transformData } from '../../super-admin/utils/transformData';
import ChangeRequestItems from './ChangeRequestItems';
import toast from 'react-hot-toast';
import { useSidebar } from '../../shared/contexts/SidebarContext';
import mixpanel from 'mixpanel-browser';
import Cookies from 'js-cookie';

const ChangeRequestsList = () => {
  const userId = Cookies.get('userId');
  const [crLists, setCRLists] = useState([]);
  const [showTasks, setShowTasks] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(1000); // items per page
  const [cRID, setCRID] = useState();
  const [totalPages, setTotalPages] = useState();
  const [globalStatus, setGlobalStatus] = useState();
  const { collapsed } = useSidebar();
  // Fetch all change requests
  const { data: changeRequests, refetch: refetchCR } = useQuery({
    queryKey: ['getCustomerChangeRequests', page, limit, showTasks, setShowTasks], // Include page and limit in queryKey
    queryFn: () => getCustomerChangeRequests(page, limit), // Pass queryFn as a function
    enabled: true // Keep it enabled
  });

  const handleFindsTasks = (id) => {
    setCRID(id);
    setShowTasks(true);
  };

  // Track page view
  useEffect(() => {
    mixpanel.track('Change Requests List Viewed', {
      user_id: userId,
      timestamp: new Date().toISOString()
    });
  }, [userId]);

  useEffect(() => {
    if (Array.isArray(changeRequests?.data)) {
      setCRLists(changeRequests?.data);
      // setTotalPages(
      //   changeRequests?.meta ? changeRequests?.meta?.total : changeRequests?.data.length / limit
      // );
    }
  }, [changeRequests]);

  useEffect(() => {
    refetchCR();
  }, [showTasks, cRID]);

  useEffect(() => {
    const data = crLists.find((item) => item.id === cRID);
    if (data) {
      setGlobalStatus(data.globalStatus);
    }
  }, [cRID, showTasks, crLists]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const formatCRListData = (item) => {
    return {
      id: item?.id,
      Customer_Name: item.deal?.lead?.user?.name || 'N/A',
      Unit_Block: `${item.deal?.unit?.unitName || 'N/A'}/${item.deal?.unit?.block?.name || 'N/A'}`,
      Project_Name: item.deal?.unit?.project?.name || 'N/A',
      No_of_Requests: item.total_requirements || 0,
      Total_Cost:
        ((item.builderStatus === 'Accepted' || item.engineerStatus === 'Accepted') &&
          item.budget) ||
        0,
      Total_Effort: `${((item.builderStatus === 'Accepted' || item.engineerStatus === 'Accepted') && item.totalDays) || '---'} Days`,
      status: item.globalStatus,
      Customer_Approval:
        item.globalStatus === 'Approved'
          ? 'Pending'
          : item.globalStatus === 'Accepted'
            ? 'Accepted'
            : 'N/A'
    };
  };

  const CRTableData = crLists?.map((item) =>
    transformData(formatCRListData(item), [
      'id',
      'Customer_Name',
      'Unit_Block',
      'Project_Name',
      'No_of_Requests',
      'Total_Cost',
      'Total_Effort',
      'status',
      'Customer_Approval'
    ])
  );

  return (
    <Layout>
      {/* Header */}
      <div
        className={`fixed z-[10] top-0 transition-all duration-300 ease-in-out ${
          collapsed ? 'left-[76px] right-0' : 'left-64 right-0'
        }`}>
        <Header data={{ name: 'Tasks' }} />
      </div>

      {/* Grid - adjusted margin top to account for new tab position */}

      <GridWrapper width={100}>
        <div className="flex justify-start flex-col align-center mt-[5rem] relative gap-5">
          {!showTasks && (
            <>
              <div className="w-full flex justify-between items-center">
                <div className="flex gap-1 justify-start items-center font-medium text-[18px]">
                  Change Requests
                </div>
              </div>
              <div className=" w-[100%]">
                <div className=" h-[calc(100vh-11rem)] overflow-auto relative table-container">
                  <style>{`
            .table-container .table-body {
              position: static !important;
              overflow-y: visible !important;
              max-height: none !important;
              height: auto !important;
              top: auto !important;
              padding-bottom: 0 !important;
            }
            .table-container .table-container {
              height: auto !important;
            }
            .table-container > div {
              height: auto !important;
            }
          `}</style>
                  <Table
                    headers={[
                      'Customer Name',
                      'Unit/Block',
                      'Project Name',
                      'No of Requests',
                      'Total Cost',
                      'Total Effort',
                      'Status',
                      'Customer Approval'
                    ]}
                    data={CRTableData}
                    identifier={'id'}
                    handleRowClick={(budget) => handleFindsTasks(budget)}
                    isWrap={true}
                  />

                  {/* <PaginationComponent
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  // isFetching={isFetching}
                /> */}
                </div>
              </div>
            </>
          )}

          {showTasks && (
            <ChangeRequestItems
              cRID={cRID}
              globalStatus={globalStatus}
              setShowTasks={setShowTasks}
            />
          )}
        </div>
      </GridWrapper>
    </Layout>
  );
};

export default ChangeRequestsList;
